<template>
	<action-card
		v-if="proposals.length || agreements.length"
		:title="$t('nav.agreements')"
		icon="handshake"
		:count="proposals.length + agreements.length"
		@open="$router.push('/agreements')"
	>
		<button
			v-for="proposal in visibleProposals"
			:key="`proposal-${proposal.id}`"
			type="button"
			class="portal-action-row"
			@click="openProposal(proposal)"
		>
			<span class="action-row-copy">
				<strong v-html="safeHeading(proposal)"></strong>
				<small>{{ $t('global.submitted') }} {{ DateTime.fromISO(proposal.dateSent).toFormat('MMM dd') }}</small>
			</span>
			<portal-icon name="chevron-right" :size="18"></portal-icon>
		</button>
		<button
			v-for="agreement in visibleAgreements"
			:key="`agreement-${agreement.id}`"
			type="button"
			class="portal-action-row"
			@click="openAgreement(agreement)"
		>
			<span class="action-row-copy">
				<strong>{{ agreement.name }}</strong>
				<small>{{ $t('global.submitted') }} {{ DateTime.fromISO(agreement.dateCreated).toFormat('MMM dd') }}</small>
			</span>
			<portal-icon name="chevron-right" :size="18"></portal-icon>
		</button>
	</action-card>
</template>

<script>
	import { DateTime } from 'luxon';
	import DOMPurify from 'dompurify';
	import ProposalDetails from '@/modules/proposal/ProposalDetails';
	import ActionCard from '@/modules/welcome/actionItems/ActionCard';

	export default {
		name: 'Proposals',

		props: ['proposals', 'agreements'],

		components: { ActionCard },

		data() {
			return { DateTime };
		},

		methods: {
			safeHeading(proposal) {
				return DOMPurify.sanitize(proposal.coverPage.heading, { ALLOWED_TAGS: [] });
			},

			openProposal(proposal) {
				this.$store.state.globalModalController
					.openModal(ProposalDetails, { proposalId: proposal.id }, false, true)
					.then(() => this.$emit('refresh'));
			},

			openAgreement(agreement) {
				const signer = agreement.signers.find(
					(candidate) => candidate.email === this.$store.state.loggedInUser.email
				);
				window.open(`/document/${agreement.id}${signer ? `.${signer.id}` : ''}`, '_blank', 'noopener');
			},
		},

		computed: {
			visibleProposals() {
				return this.proposals.slice(0, 5);
			},

			visibleAgreements() {
				return this.agreements.slice(0, Math.max(0, 5 - this.visibleProposals.length));
			},
		},
	};
</script>
